import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import propTypes from 'prop-types'
import {
  deleteMessages,
  getMessageList,
  messageRowSelect,
} from '../../store/action/callback.action'
import { getSurgeonList } from '../../store/action/surgeon.action'
import { Col, Row } from 'antd'
import Avatar from 'antd/lib/avatar/avatar'
import _ from 'lodash'
import ScrollBar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'
import MessageSurgeon from './message.surgeon'
import {
  fechactioncase,
  messageSelectBox,
} from '../../store/action/actioncases.action'
import util from '../../util/util'
import { messageScope } from '../../util/messagefilter'
const SurgeonList = (props) => {
  useEffect(() => {
    props.fetchSurgeons(props.customer?._id || props?.decoded?.customer)
  }, [])

  useEffect(() => {
    const surgeonList = props.surgeons?.filter((surgeon) => surgeon.showinlist)
    if (surgeonList?.length > 0) {
      // props.fetchMessages({
      //     ...props.filters,
      //     pagination: {current: 1,pageSize: 20},
      //     surgeonid: props.surgeons[0]._id,
      //     sort: props.sort
      // }, props.selectedRequests)
      let selectedData = !_.isEmpty(props.selectedIndex)
        ? { key: [props.selectedIndex], row: [] }
        : { key: [surgeonList[0]._id], row: [] }
      props.fechactioncase(
        {
          metadata: { current: 1, pageSize: 20 },
          filters: {
            archived: false,
            ...props.msgfilter,
            ...messageScope({
              customer: props.customer,
              decoded: props.decoded,
            }),
            surgeonId: _.isEmpty(props.selectedIndex)
              ? surgeonList[0]._id
              : props.selectedIndex,
          },
          sorter: {
            field: 'lastUpdated',
            order: 'descend',
          },
        },
        selectedData
      )
    }
  }, [props.surgeons])

  const handleClick = (surgeon) => {
    // props.fetchMessages({
    //     ...props.filters,
    //     pagination: {current: 1,pageSize: 20},
    //     surgeonid: surgeon._id,
    //     sort: props.sort
    // }, props.selectedRequests)
    // props.messageSelectBox(surgeonList[0]._id)
    props.fechactioncase(
      {
        metadata: { current: 1, pageSize: 20 },
        filters: {
          archived: false,
          ...props.msgfilter,
          ...messageScope({
            customer: props.customer,
            decoded: props.decoded,
          }),
          surgeonId: surgeon._id,
        },
        sorter: {
          field: 'lastUpdated',
          order: 'descend',
        },
      },
      { key: [surgeon._id], row: [surgeon] }
    )
  }
  const renderSurgeons = () => {
    return props.surgeons?.map((surgeon) => (
      <MessageSurgeon surgeon={surgeon} handleClick={handleClick} />
    ))
  }

  return (
    <Row className='ms-cont'>
      <Col flex='auto'>
        <Row className='ms-header'>Providers</Row>
        <Row>
          <ScrollBar style={{ height: props.height - 53 - 64, width: '100%' }}>
            <Col flex='auto'>{renderSurgeons()}</Col>
          </ScrollBar>
        </Row>
      </Col>
    </Row>
  )
}

SurgeonList.propTypes = {}

const mapStateToProps = (state) => {
  return {
    decoded: util.verifyToken(state.profile.token, true),
    customer: state.profile.customer,
    user: state.profile.user,
    pagination: state.message.pagination,
    requests: state.message.requests,
    isLoading: state.message.isLoading,
    filters: state.message.filters,
    selectedRequests: state.message.selectedRequests,
    selectedIndex: state.message.selectedIndex,
    selectedRow: state.message.selectedRow,
    surgeons: state.surgeon.surgeons,
    msgfilter: state.message.filter,
    sort: state.message.sort,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMessages: (filter, selected) =>
      dispatch(getMessageList(filter, selected)),
    onRowSelect: (rows) => dispatch(messageRowSelect(rows)),
    deleteMessages: (ids) => dispatch(deleteMessages(ids)),
    fetchSurgeons: (customer) => dispatch(getSurgeonList(customer)),
    fechactioncase: (params, selected) =>
      dispatch(fechactioncase(params, selected)),
    messageSelectBox: (data) => dispatch(messageSelectBox(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SurgeonList)
